import React, { useEffect, useMemo, useState } from 'react';
import { Dialog, PromptProps } from '@fx-ui/fine-design';
import { ErrorInput } from '@fx-ui/jdy-design-biz';
import classNames from 'classnames';
import { isNumber, size, trim } from '~/utils';
import Intl from '@fx-ui/intl';

interface IErrorPromptProps extends PromptProps {
    errMsg?: string;
    maxLength?: number;
}

const ErrorPrompt: React.FC<IErrorPromptProps> = (props) => {
    const {
        className,
        style,
        title,
        visible,
        text4Ok = Intl.get('ok'),
        text4Cancel = Intl.get('cancel'),
        type4Ok = 'primary',
        type4Cancel = 'negative',
        onOk,
        onCancel,
        placeholder,
        defaultValue = '',
        autoSelect = true,
        errMsg,
        maxLength
    } = props;

    const [value, setValue] = useState('');

    const overLimit = useMemo(() => {
        return isNumber(maxLength) && size(trim(value)) > maxLength;
    }, [maxLength, value]);

    useEffect(() => {
        if (visible) {
            setValue(defaultValue);
        }
    }, [visible]);

    const handleOk = (e: React.MouseEvent) => {
        return onOk && onOk(value, e);
    };

    return (
        <Dialog
            className={classNames('fx-error-prompt', className)}
            style={style}
            visible={visible}
            text4Ok={text4Ok}
            text4Cancel={text4Cancel}
            props4Ok={{ type: type4Ok }}
            props4Cancel={{ type: type4Cancel }}
            closable={false}
            separator={{ footer: false }}
            contentPadding={false}
            width={440}
            height={160}
            onOk={handleOk}
            onCancel={onCancel}
        >
            <div className="title">{title}</div>
            <ErrorInput
                errMsg={errMsg}
                inputState={overLimit ? 'error' : 'normal'}
                placeholder={placeholder}
                autoSelect={autoSelect}
                value={value}
                onChange={setValue}
                style={{ width: '100%', height: 36 }}
            />
        </Dialog>
    );
};

export default ErrorPrompt;
